export default "/static/src/images/OB_PrimaryLogo_01-FullColor.png";